/* eslint-disable import/prefer-default-export */
import { requestSurveyLink } from '../../utils/requests';

export function getSurveyLink([pCode]) {
  return requestSurveyLink
    .get('', { params: { pCode } })
    .then(res => ({ res }))
    .catch(err => ({ err }));
}
